import { render } from "./MainPage.vue?vue&type=template&id=6559f759&scoped=true&ts=true"
import script from "./MainPage.ts?vue&type=script&lang=ts"
export * from "./MainPage.ts?vue&type=script&lang=ts"

import "./MainPage.vue?vue&type=style&index=0&id=6559f759&lang=scss"
import "./MainPage.vue?vue&type=style&index=1&id=6559f759&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6559f759"]])

export default __exports__